import script from "./SkillManage.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillManage.vue?vue&type=script&setup=true&lang=js"

import "./SkillManage.vue?vue&type=style&index=0&id=e8f6e5a0&lang=scss&scoped=true"
import "./SkillManage.vue?vue&type=style&index=1&id=e8f6e5a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8f6e5a0"]])

export default __exports__